import { Collapse, Button, Row, Col, Empty, Space, Modal, Typography, Tag } from "antd";
import { 
  Clock, Calendar, Trash2, CheckCircle2, ClipboardList, Activity, Users, 
  Shield, Eye, Siren, ClipboardCheck, Target, Info, AlertCircle, 
  MessageSquare, Hammer, Wrench, FileText, Search, IdCard, MapPin 
} from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import DataGroup from "./DataGroup";
import DataItem from "./DataItem";
import Subtitle from "./Subtitle";
import AddVisitForm from "./forms/general/AddVisitForm";
import moment from "moment";
import "moment/locale/es";
moment.locale("es-mx");

const { Text } = Typography;

export default function VisitPreview(props) {
  const { id, verification, visits, setVisits } = props;
  const [AddVisitFormVisible, setAddVisitFormVisible] = useState(false);
  const [tipo, setTipo] = useState();

  useEffect(() => {
    if (verification) {
      console.log("--- FRONTEND: Calculating 'tipo' for Inspection List ---");
      console.log("Verification Data:", {
        TipoVerificacionID: verification.TipoVerificacionID,
        Capacidad: verification.Capacidad,
        AlcanceVerificacion: verification.AlcanceVerificacion
      });

      if (verification.TipoVerificacionID === 5 && verification.Capacidad === 0) {
        console.log("Matched: TipoVerificacionID === 5 && Capacidad === 0 -> Setting tipo to 'vieja'");
        setTipo("vieja");
      } else if (verification.TipoVerificacionID === 5 && verification.Capacidad > 0) {
        console.log("Matched: TipoVerificacionID === 5 && Capacidad > 0 -> Setting tipo to 'viejatro'");
        setTipo("viejatro");
      } else if (verification.AlcanceVerificacion < 100) {
        console.log("Matched: AlcanceVerificacion < 100 -> Setting tipo to 'menor100'");
        setTipo("menor100");
      } else if (verification.AlcanceVerificacion > 100) {
        console.log("Matched: AlcanceVerificacion > 100 -> Setting tipo to 'mayor100'");
        setTipo("mayor100");
      } else {
        console.log("No specific condition matched for 'tipo'");
      }
    }
  }, [verification]);

  const handleDeleteVisit = (visitId) => {
    Modal.confirm({
      title: "Eliminar visita",
      content: "¿Estás seguro de que deseas eliminar esta visita?",
      okText: "Borrar",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/visitas/${visitId}`)
          .then(() => {
            axios.get(`${process.env.REACT_APP_API_URL}/visitas/${id}`).then((res) => {
              setVisits(res.data);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      },
    });
  };

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 16,
    xl: 16,
  };

  const responsiveTestigo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 8,
  }

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col span={24} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            icon={<CheckCircle2 size={16} style={{marginRight: '8px'}} />}
            onClick={() => {
              setAddVisitFormVisible(true);
            }}
            style={{ borderRadius: '6px', display: 'inline-flex', alignItems: 'center' }}
          >
            Agregar visita
          </Button>
        </Col>
      </Row>
      {visits && visits.length > 0 ? (
        <Collapse bordered={false} accordion expandIconPosition="right">
          {visits.map((visit, index) => (
            <Collapse.Panel
              key={visit.VisitaID}
              header={
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <div style={{ 
                    width: '32px', height: '32px', borderRadius: '50%', 
                    border: '1px solid #1890ff', display: 'flex', 
                    alignItems: 'center', justifyContent: 'center', 
                    backgroundColor: '#fff', flexShrink: 0
                  }}>
                    <CheckCircle2 size={18} color="#1890ff" />
                  </div>
                  <div style={{ marginLeft: '12px', flex: 1 }}>
                    <Text strong style={{ fontSize: '14px' }}>Visita {index + 1}</Text>
                    <div style={{ display: 'flex', gap: '16px', marginTop: '2px' }}>
                      <Text type="secondary" style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <Calendar size={12} />
                        {visit.FechaVisita ? moment.utc(visit.FechaVisita).format("LL") : "Sin fecha"}
                      </Text>
                      {visit.HoraInicio && (
                        <Text type="secondary" style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', color: '#1890ff' }}>
                          <Clock size={12} />
                          {`${moment(visit.HoraInicio, "HH:mm").format("HH:mm")} - ${visit.HoraTermino ? moment(visit.HoraTermino, "HH:mm").format("HH:mm") : "..."}`}
                        </Text>
                      )}
                    </div>
                  </div>
                </div>
              }
              extra={
                <Button
                  type="text"
                  danger
                  shape="circle"
                  icon={<Trash2 size={16} />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteVisit(visit.VisitaID);
                  }}
                />
              }
              style={{ 
                marginBottom: '12px', 
                background: '#fafafa', 
                borderRadius: '12px', 
                border: '1px solid #f0f0f0',
                overflow: 'hidden'
              }}
            >
              <Subtitle title="Desarrollo de la visita" marginTop={0} />
              <Row gutter={[16, 16]}>
                <Col {...responsiveInfo}>
                  <DataGroup mainData={visit} setMainData={setVisits} formName={"Desarrollo de la visita"} icon={<ClipboardList size={18} />}>
                    <Row gutter={[16, 0]}>
                      <Col span={24}>
                        <DataItem
                          icon={<ClipboardCheck size={15} />}
                          iconColor="#1890ff"
                          keyName="Lista de inspección"
                          value={
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                              {visit.ListaInspeccion?.split(",").map((item, i) => (
                                <Tag color="blue" key={i} style={{ margin: 0 }}>
                                  {item.trim()}
                                </Tag>
                              ))}
                            </div>
                          }
                          fieldWidth={6}
                          layout="vertical"
                          button={visit.ListaInspeccion?.split(",").length > 1 ? "Descargar ZIP" : `Descargar ${visit.ListaTipo}`}
                          buttonFunction={() => {
                            const url = visit.ListaTipo === "Fija"
                              ? `${process.env.REACT_APP_API_URL}/formatos/listainspeccion/fija/${visit.ListaInspeccion}/${visit.VisitaID}`
                              : `${process.env.REACT_APP_API_URL}/formatos/listainspeccion/variable/${tipo}/${visit.ListaInspeccion}/${visit.VisitaID}`;
                            
                            console.log("--- FRONTEND: Download Inspection List START ---");
                            console.log("Request URL:", url);

                            axios({
                              method: "get",
                              url: url,
                              responseType: "blob",
                            })
                              .then((res) => {
                                const isZip = res.headers["content-type"] === "application/zip";
                                const fileName = isZip 
                                  ? `Listas de inspección ${new Date().getTime()}.zip`
                                  : `Lista de inspección ${new Date().getTime()}.docx`;
                                
                                const blob = new Blob([res.data], {
                                  type: res.headers["content-type"],
                                });
                                
                                const link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName; 
                                link.click();
                                console.log("--- FRONTEND: Download Inspection List END (Success) ---");
                              })
                              .catch((err) => {
                                console.error("--- FRONTEND: Download Inspection List ERROR ---");
                                console.error(err);
                              });
                          }}
                        />
                      </Col>
                      <Col span={24}><DataItem icon={<Target size={15} />} iconColor="#fa8c16" keyName="Objeto" value={visit.ObjetoVisita} valueType="longString" layout="vertical" /></Col>
                      <Col span={24}><DataItem icon={<Info size={15} />} iconColor="#1890ff" keyName="Circunstancia" value={visit.CircunstanciaVisita} valueType="longString" layout="vertical" /></Col>
                      <Col span={24}><DataItem icon={<AlertCircle size={15} />} iconColor="#ff4d4f" keyName="No conformidades" value={visit.NoConformidadesEncargado} valueType="longString" layout="vertical" /></Col>
                      <Col span={24}><DataItem icon={<MessageSquare size={15} />} iconColor="#faad14" keyName="Observaciones" value={visit.ObservacionesEncargado} valueType="longString" layout="vertical" /></Col>
                      <Col span={24}><DataItem icon={<Hammer size={15} />} iconColor="#52c41a" keyName="Acciones" value={visit.Acciones} valueType="longString" layout="vertical" fieldWidth={4} /></Col>
                    </Row>
                  </DataGroup>
                </Col>
              </Row>

              <Subtitle title="Pruebas realizadas" marginTop={16} />
              <Row gutter={[16, 16]}>
                <Col {...responsiveInfo}>
                  <DataGroup mainData={visit} setMainData={setVisits} formName="Pruebas" verification={verification} icon={<Activity size={18} />}>
                    <div className="data-subgroup-container">
                      <div className="data-subgroup-title">1. Resistencia de aislamiento</div>
                      <Row gutter={[16, 0]}>
                        <Col span={24}><DataItem icon={<CheckCircle2 />} iconColor="#52c41a" keyName="Resultado" value={visit.ResResistenciaAislamiento} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Wrench />} iconColor="#1890ff" keyName="Equipo" value={visit.EqResistenciaAislamiento} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<FileText />} iconColor="#fa8c16" keyName="Descripción" value={visit.DescAislamiento} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Search />} iconColor="#722ed1" keyName="Observaciones" value={verification?.TipoVerificacionID === 5 ? visit.ObsAislamiento : null} layout="vertical" /></Col>
                      </Row>
                    </div>

                    <div className="data-subgroup-container">
                      <div className="data-subgroup-title">2. Continuidad eléctrica</div>
                      <Row gutter={[16, 0]}>
                        <Col span={24}><DataItem icon={<CheckCircle2 />} iconColor="#52c41a" keyName="Resultado" value={visit.ResContinuidadElectrica} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Wrench />} iconColor="#1890ff" keyName="Equipo" value={visit.EqContinuidadElectrica} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<FileText />} iconColor="#fa8c16" keyName="Descripción" value={visit.DescContinuidad} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Search />} iconColor="#722ed1" keyName="Observaciones" value={verification?.TipoVerificacionID === 5 ? visit.ObsContinuidad : null} layout="vertical" /></Col>
                      </Row>
                    </div>

                    <div className="data-subgroup-container">
                      <div className="data-subgroup-title">3. Red de tierras</div>
                      <Row gutter={[16, 0]}>
                        <Col span={24}><DataItem icon={<CheckCircle2 />} iconColor="#52c41a" keyName="Resultado" value={visit.ResResistenciaTierraFisica} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Wrench />} iconColor="#1890ff" keyName="Equipo" value={visit.EqResistenciaTierraFisica} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<FileText />} iconColor="#fa8c16" keyName="Descripción" value={visit.DescElectrodos} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Search />} iconColor="#722ed1" keyName="Observaciones" value={verification?.TipoVerificacionID === 5 ? visit.ObsElectrodos : null} layout="vertical" /></Col>
                      </Row>
                    </div>

                    <div className="data-subgroup-container">
                      <div className="data-subgroup-title">4. Polaridad y Receptáculos</div>
                      <Row gutter={[16, 0]}>
                        <Col span={24}><DataItem icon={<CheckCircle2 />} iconColor="#52c41a" keyName="Resultado" value={visit.ResPolaridadContactos} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Wrench />} iconColor="#1890ff" keyName="Equipo" value={visit.EqPolaridadContactos} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<FileText />} iconColor="#fa8c16" keyName="Descripción" value={visit.DescPolaridad} layout="vertical" /></Col>
                        <Col span={24}><DataItem icon={<Search />} iconColor="#722ed1" keyName="Observaciones" value={verification?.TipoVerificacionID === 5 ? visit.ObsPolaridad : null} layout="vertical" /></Col>
                      </Row>
                    </div>

                    {verification?.TipoVerificacionID === 5 && (
                      <div className="data-subgroup-container" style={{ border: '1px dashed #1890ff', background: 'rgba(24, 144, 255, 0.05)' }}>
                        <div className="data-subgroup-title" style={{ color: '#0050b3' }}>Verificación Periódica</div>
                        <Row gutter={[16, 0]}>
                          <Col span={24}><DataItem icon={<Shield />} iconColor="#1890ff" keyName="Protecciones" value={visit.ObsProtecciones} layout="vertical" /></Col>
                          <Col span={24}><DataItem icon={<Eye />} iconColor="#1890ff" keyName="Subestaciones" value={visit.ObsLocalesSubestaciones} layout="vertical" /></Col>
                          <Col span={24}><DataItem icon={<Siren />} iconColor="#1890ff" keyName="Emergencia" value={visit.ObsSistemasEmergencia} layout="vertical" /></Col>
                        </Row>
                      </div>
                    )}
                  </DataGroup>
                </Col>
              </Row>

              <Subtitle title="Testigos" marginTop={16} />
              <Row gutter={[16, 16]}>
                <Col {...responsiveTestigo}>
                  <DataGroup
                    title={!visit?.NombreCompletoPT1 ? "TESTIGO 1" : `TESTIGO 1: ${visit?.NombreCompletoPT1}`}
                    subtitle={visit?.TipoPersonaPT1 && visit?.NacionalidadPT1 ? `Persona ${visit.TipoPersonaPT1}, ${visit.NacionalidadPT1}` : null}
                    mainData={visit}
                    setMainData={setVisits}
                    formName="Testigo 1"
                    icon={<Users size={18} />}
                  >
                    <DataItem icon={<IdCard size={15} />} iconColor="#1890ff" keyName={visit.TipoDatoPT1 || "Identificación"} value={visit.DatoPT1_T} valueType="string" fieldWidth={8} />
                    <DataItem icon={<MapPin size={15} />} iconColor="#ff4d4f" keyName="Domicilio" value={visit.DomicilioPT1_T} valueType="string" fieldWidth={8} />
                  </DataGroup>
                </Col>
                <Col {...responsiveTestigo}>
                  <DataGroup
                    title={!visit?.NombreCompletoPT2 ? "TESTIGO 2" : `TESTIGO 2: ${visit?.NombreCompletoPT2}`}
                    subtitle={visit?.TipoPersonaPT2 && visit?.NacionalidadPT2 ? `Persona ${visit.TipoPersonaPT2}, ${visit.NacionalidadPT2}` : null}
                    mainData={visit}
                    setMainData={setVisits}
                    formName="Testigo 2"
                    icon={<Users size={18} />}
                  >
                    <DataItem icon={<IdCard size={15} />} iconColor="#1890ff" keyName={visit.TipoDatoPT2 || "Identificación"} value={visit.DatoPT2_T} valueType="string" fieldWidth={8} />
                    <DataItem icon={<MapPin size={15} />} iconColor="#ff4d4f" keyName="Domicilio" value={visit.DomicilioPT2_T} valueType="string" fieldWidth={8} />
                  </DataGroup>
                </Col>
              </Row>
            </Collapse.Panel>
          ))}
        </Collapse>
      ) : (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "300px",
          flexDirection: "column",
          background: "#fff",
          borderRadius: "12px",
          border: "1px dashed #d9d9d9",
          margin: "20px 0"
        }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Space direction="vertical" size={0}>
                <Text strong style={{ fontSize: "16px", color: "#262626" }}>Sin visitas registradas</Text>
                <Text type="secondary">Agregue una visita para visualizar el desarrollo y pruebas.</Text>
              </Space>
            }
          >
            <Button type="primary" onClick={() => setAddVisitFormVisible(true)}>
              Agregar primera visita
            </Button>
          </Empty>
        </div>
      )}
      <AddVisitForm id={id} setVisits={setVisits} visible={AddVisitFormVisible} setVisible={setAddVisitFormVisible} />
    </>
  );
}
